import { Group } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

import { MandatoryField } from '../components';
import type { MatchedColumns } from '../types.ts';

/**
 * Note: The fields that are mandatory are the ones in private_constants.("debtor" | "invoice")_import_columns.required_fields.
 * Since there are relatively few and will likely never change, I hardcoded the checks in this component
 * which was far simpler and cleaner
 */
export function useMandatoryFieldValidation(
  isInvoiceMode: boolean,
  matchedColumns: MatchedColumns,
) {
  const { t } = useTranslation();
  if (isInvoiceMode) {
    const isNameValid = (() => {
      if (matchedColumns.includes('full_name')) return true;
      if (matchedColumns.includes('first_name') && matchedColumns.includes('last_name'))
        return true;

      return false;
    })();
    const isIssueDateValid = matchedColumns.includes('issue_date');
    const isAmountValid =
      matchedColumns.includes('remaining_balance') || matchedColumns.includes('total_tvac');
    const isReferenceValid = matchedColumns.includes('reference');

    const areMandatoryFieldsMatched =
      isNameValid && isIssueDateValid && isReferenceValid && isAmountValid;

    return {
      areMandatoryFieldsMatched,
      Indicators: (
        <Group>
          <MandatoryField isChecked={isNameValid}>
            {t(i18nKeys.MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.NAME)}
          </MandatoryField>
          <MandatoryField isChecked={isIssueDateValid}>
            {t(i18nKeys.MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.ISSUE_DATE)}
          </MandatoryField>
          <MandatoryField isChecked={isReferenceValid}>
            {t(i18nKeys.MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.REFERENCE)}
          </MandatoryField>
          <MandatoryField isChecked={isAmountValid}>
            {t(i18nKeys.MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.AMOUNT)}
          </MandatoryField>
        </Group>
      ),
    };
  }

  const isDebtorIdentifierValid =
    matchedColumns.includes('internal_debtor_id') ||
    matchedColumns.includes('full_name') ||
    matchedColumns.includes('vat_number') ||
    matchedColumns.includes('debtor_csv_id');

  const areMandatoryFieldsMatched = isDebtorIdentifierValid;

  return {
    areMandatoryFieldsMatched,
    Indicators: (
      <Group>
        <MandatoryField isChecked={isDebtorIdentifierValid}>
          {t(i18nKeys.MODULES.IMPORT.MANDATORY_FIELDS.DEBTORS.IDENTIFIER)}
        </MandatoryField>
      </Group>
    ),
  };
}
